module.exports = __webpack_public_path__ + "static/Mr John Opondo-088f7d062165e502e341c7843cb5559f.png";